module.exports = __webpack_public_path__ + "img/sliding.895a29b.svg";